// import React, { useState, useEffect, useRef } from "react";
// import Layout, { Container } from "../components/layout";
// import { RiDeleteBin6Fill } from "react-icons/ri";
// import Input from "../components/inputContainer";
// import { FiUpload } from "react-icons/fi";
// import { useUser } from "../config/userProvider";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { InfiLoader } from "../components/loader";
// import { motion } from "framer-motion";
// import { BsArrowRight } from "react-icons/bs";
// import Card from "../components/card";
// import SearchContainer from "../components/searchContainer";
// import { FaChevronDown } from "react-icons/fa6";
// import { CiEdit } from "react-icons/ci";
// // import { AiTwotoneEdit } from "react-icons/ai";
// // import { TiTick } from "react-icons/ti";
// // import { RxCross2 } from "react-icons/rx";
// // import { BlackButton } from "../components/buttonContainer";
// // import { BiLogoShopify } from "react-icons/bi";
// // import { SiConfluence } from "react-icons/si";
// // import { HiDotsHorizontal } from "react-icons/hi";
// // import { CgDetailsMore } from "react-icons/cg";
// const IntrigationData = [
//   {
//     logoSrc: "/gupshup_logo.svg",
//     title: "gupshup",
//     description:
//       "Boost sales with customer photos, videos, and other social proof",
//     badgeText: "service",
//     // badgeIcon: <BiLogoShopify className="text-sm" />,
//   },
//   {
//     logoSrc: "/shopify_icon.svg",
//     title: "shopify",
//     description:
//       "Boost sales with customer photos, videos, and other social proof",
//     badgeText: "integration",
//     // badgeIcon: <BiLogoShopify className="text-sm" />,
//   },
//   {
//     logoSrc: "/Gmail_icon_(2020).svg",
//     title: "SMTP",
//     description:
//       "Boost sales with customer photos, videos, and other social proof",
//     badgeText: "service",
//     // badgeIcon: <BiLogoShopify className="text-sm" />,
//   },
//   {
//     logoSrc: "/twilio-tile.svg",
//     title: "twilio",
//     description:
//       "Boost sales with customer photos, videos, and other social proof",
//     badgeText: "service",
//     // badgeIcon: <BiLogoShopify className="text-sm" />,
//   },
//   {
//     logoSrc: "/fynd.png",
//     title: "fynd",
//     description:
//       "Boost sales with customer photos, videos, and other social proof",
//     badgeText: "integration",
//     // badgeIcon: <BiLogoShopify className="text-sm" />,
//   },
//   {
//     logoSrc: "/ginesys.png",
//     title: "Genesis",
//     description:
//       "Boost sales with customer photos, videos, and other social proof",
//     badgeText: "integration",
//     // badgeIcon: <BiLogoShopify className="text-sm" />,
//   },
//   {
//     logoSrc: "/kringle.png",
//     title: "kringle",
//     description:
//       "Boost sales with customer photos, videos, and other social proof",
//     badgeText: "integration",
//     // badgeIcon: <BiLogoShopify className="text-sm" />,
//   },
//   {
//     logoSrc: "/optculture.png",
//     title: "opt culture",
//     description:
//       "Boost sales with customer photos, videos, and other social proof",
//     badgeText: "integration",
//     // badgeIcon: <BiLogoShopify className="text-sm" />,
//   },
//   {
//     logoSrc: "/invitereferrals.png",
//     title: "invite referral ",
//     description:
//       "Boost sales with customer photos, videos, and other social proof",
//     badgeText: "integration",
//     // badgeIcon: <BiLogoShopify className="text-sm" />,
//   },
// ];

// const Integration = () => {
//   let { userData } = useUser();
//   const [isOpen, setIsOpen] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const [popupType, setPopupType] = useState("");
//   // const [activeSection, setActiveSection] = useState("services");
//   const [updateDetail, setUpdateDetail] = useState("");
//   const [loading, setLoading] = useState(false);

//   // Verification states
//   const [verificationData, setVerificationData] = useState({
//     gst: {
//       number: "",
//       isVerified: false,
//       error: "",
//       document: null,
//     },
//     pan: {
//       number: "",
//       isVerified: false,
//       error: "",
//       document: null,
//     },
//     fssai: {
//       number: "",
//       isVerified: false,
//       error: "",
//       document: null,
//     },
//     trademark: {
//       number: "",
//       isVerified: false,
//       error: "",
//       document: null,
//     },
//   });

//   // const handleVerificationInput = (type, value) => {
//   //   setVerificationData((prev) => ({
//   //     ...prev,
//   //     [type]: {
//   //       ...prev[type],
//   //       number: value,
//   //       error: "",
//   //       isVerified: false,
//   //     },
//   //   }));
//   // };

//   // const handleVerify = (type) => {
//   //   // Simulate verification API call
//   //   setTimeout(() => {
//   //     if (verificationData[type].number.length < 5) {
//   //       setVerificationData((prev) => ({
//   //         ...prev,
//   //         [type]: {
//   //           ...prev[type],
//   //           error: "Invalid number format",
//   //           isVerified: false,
//   //         },
//   //       }));
//   //     } else {
//   //       setVerificationData((prev) => ({
//   //         ...prev,
//   //         [type]: {
//   //           ...prev[type],
//   //           error: "",
//   //           isVerified: true,
//   //         },
//   //       }));
//   //     }
//   //   }, 1000);
//   // };

//   // const handleFileUpload = (type, file) => {
//   //   setVerificationData((prev) => ({
//   //     ...prev,
//   //     [type]: {
//   //       ...prev[type],
//   //       document: file,
//   //     },
//   //   }));
//   // };

//   // const toggleDrawer = () => {
//   //   setIsOpen(!isOpen);
//   // };
//   // const deletePopup = () => {
//   //   setShowDeleteMemberPopup(!showDeleteMemberPopup);
//   // };
//   // const handleDelete = () => {
//   //   setShowDeleteMemberPopup(false);
//   // };

//   // const [showAddMemberPopup, setShowAddMemberPopup] = useState(false);
//   // const [showDeleteMemberPopup, setShowDeleteMemberPopup] = useState(false);
//   const [formdata, setFormdata] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     role: "",
//     stores: true,
//     products: true,
//     orders: true,
//     settings: true,
//     reports: true,
//     users: true,
//     analytics: true,
//     magento: false,
//     shopify: false,
//     manual: true,
//   });

//   // const handleInputChange = (e) => {
//   //   const { name, value } = e.target;
//   //   setFormdata({ ...formdata, [name]: value });
//   // };
//   // console.log(formdata);

//   // const handleToggleChange = (key) => {
//   //   setFormdata((prevFormData) => ({
//   //     ...prevFormData,
//   //     [key]: !prevFormData[key],
//   //   }));
//   //   if (key === "shopify" || key === "magento") {
//   //     setShowPopup(true);
//   //     setPopupType(key);
//   //   }
//   // };

//   // const TabBarItem = ({ label, isActive, onClick }) => {
//   //   return (
//   //     <button
//   //       className={`md:py-2 px-6 text-xs md:text-base  rounded-md rounded-b-none  ${
//   //         isActive
//   //           ? "md:font-semibold bg-zinc-950 text-white "
//   //           : " text-gray-500 hover:text-black"
//   //       }`}
//   //       onClick={onClick}
//   //     >
//   //       {label}
//   //     </button>
//   //   );
//   // };

//   const Content = ({ label, value }) => {
//     return (
//       <div className="grid grid-cols-2 text-xs md:text-base">
//         <p className="font-semibold ">{label}:</p>
//         <p className="text-slate-500 break-words">{value}</p>
//       </div>
//     );
//   };

//   const [venderDetails, setVenderDetails] = useState("");
//   let vendorObjId = userData?.vendorDetails?.vendorObjId;
//   const [verifiedPan, setVerifedPan] = useState(false);
//   const [verifiedGst, setVerifedGst] = useState(false);
//   const [gstNumber, setGstNumber] = useState("");
//   const [panNumber, setPanNumber] = useState("");

//   useEffect(() => {
//     setLoading(true);
//     let config = {
//       method: "get",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/api/vendor/get/${vendorObjId}`,
//       headers: {},
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         setLoading(false);
//         setVenderDetails(response.data);
//         setUpdateDetail(response.data.vendorDetails);
//         // GST Details
//         setGstNumber(response.data.vendorDetails?.gstDetails?.gstNumber);
//         if (response.data.vendorDetails?.gstDetails?.gstNumber) {
//           setVerifedGst(
//             !response.data.vendorDetails?.gstDetails?.gstDocument || false
//           );
//         }
//         // PAN Details
//         setPanNumber(response.data.vendorDetails?.panDetails?.panNumber);
//         if (response.data.vendorDetails?.panDetails?.panNumber) {
//           setVerifedPan(
//             !response.data.vendorDetails?.panDetails?.panDocument || false
//           );
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//         setLoading(false);
//       });
//   }, []);

//   console.log("userData", userData);
//   console.log("venderDetails", venderDetails);

//   //------------------------------------------ Pan DATA Handler -------------------------------------------------------------
//   const [panError, setPanError] = useState("");
//   const [panDocument, setPanDocument] = useState("");

//   const [penDocument, setPenDocument] = useState("");
//   const [panProccessing, setPanProccessing] = useState(false);
//   const [panLoading, setPanLoading] = useState(false);

//   const panVarificationHandler = () => {
//     setPanProccessing(true);
//     let data = JSON.stringify({
//       pan_number: panNumber,
//     });

//     let config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/validation/pan/validate`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         if (response.data.success === true) {
//           setVerifedPan(true);
//           setPanError("");
//           setPenDocument(response.data.response.data);
//           setPanProccessing(false);
//         } else {
//           setVerifedPan(false);
//           setPenDocument("");
//           setPanError("Incorrect PAN number");
//           setPanProccessing(false);
//         }
//       })
//       .catch((error) => {
//         setPenDocument("");
//         setPanError("something went wrong");
//         console.log(error);
//         setPanProccessing(false);
//       });
//   };

//   useEffect(() => {
//     if (
//       !updateDetail?.panDetails?.panNumber &&
//       panNumber &&
//       panNumber.length >= 10
//     ) {
//       panVarificationHandler();
//     }
//   }, [panNumber]);

//   const PanDocUploadHandler = () => {
//     setPanLoading(true);
//     if (panDocument && panNumber) {
//       let data = JSON.stringify({
//         vendorObjId: vendorObjId,
//         panNumber: panNumber,
//         panDocument: panDocument?.name,
//       });

//       let config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         url: `${apiurl}/admin/v1/validation/pan/update`,
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: data,
//       };

//       axios
//         .request(config)
//         .then((response) => {
//           console.log(JSON.stringify(response.data));
//           if (response.data.success === true) {
//             setUpdateDetail(response.data.message?.vendorDetails);
//             setPanLoading(false);
//             setVerifedPan(false);
//           }
//         })
//         .catch((error) => {
//           setPanLoading(false);

//           console.log(error);
//         });
//     }
//   };
//   //------------------------------------------ Document DATA Handler -------------------------------------------------------------
//   const [gstError, setGstError] = useState("");
//   const [gstDocument, setGstDocument] = useState("");
//   const [GstDetails, setGstDetails] = useState("");
//   const [gstProccessing, setGstProccessing] = useState(false);
//   const [gstLoading, setGstLoading] = useState(false);

//   useEffect(() => {
//     setTimeout(() => {
//       setGstError("");
//       setPanError();
//     }, 5000);
//   }, [panError, gstError]);

//   const handleSave = async (data) => {
//     try {
//       const response = await fetch("/api/smtp/save", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(data),
//       });
//       const result = await response.json();
//       console.log("Saved successfully:", result);
//     } catch (error) {
//       console.error("Error saving SMTP details:", error);
//     }
//   };

//   const handleGetAll = async () => {
//     try {
//       const response = await fetch("/api/smtp/all");
//       const result = await response.json();
//       console.log("SMTP Details:", result);
//     } catch (error) {
//       console.error("Error fetching SMTP details:", error);
//     }
//   };

//   const [isExplore, setIsExplore] = useState(false);
//   const [choosenInstallCard, setChoosenInstallCard] = useState(null);
//   const [showInstallOptions, setShowInstallOptions] = useState("");
//   const [formData, setFormData] = useState(null);
//   const [showInstallApps, setShowInstallApps] = useState();
//   const [isEdit, setIsEdit] = useState("");

//   // const [editIntrigrations, setEditIntrigrations] = useState("");
//   // const handleInstall = (data) => {
//   //   setChoosenInstallCard(data);
//   // };

//   useEffect(() => {
//     FetchIntrigationList();
//   }, []);

//   const FetchIntrigationList = () => {
//     setLoading(true);
//     let data = JSON.stringify({
//       vendorObjId: vendorObjId,
//     });

//     let config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/config/get`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         if (response.data.success) {
//           setShowInstallApps([
//             ...response.data.data?.integrations,
//             ...response.data.data?.services,
//           ]);
//           setLoading(false);
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   const InputHandler = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const SubmitInstallConfigurations = (e, platform, type) => {
//     setLoading(true);
//     e.preventDefault();

//     const getIntegrationDetails = () => {
//       if (platform === "shopify") {
//         return {
//           storeUrl: formData?.storeUrl,
//           apiKey: formData?.apiKey,
//           apiSecret: formData?.apiSecret,
//           accessToken: formData?.accessToken,
//         };
//       }
//       if (platform === "SMTP") {
//         return {
//           host: formData?.host,
//           port: formData?.port,
//           username: formData?.username,
//           password: formData?.password,
//           fromEmail: formData?.fromEmail,
//         };
//       }
//       return null;
//     };

//     const getServiceDetails = () => ({
//       apiKey: formData?.apiKey,
//       apiSecret: formData?.apiSecret,
//       senderId: formData?.senderId,
//     });

//     const requestData = {
//       vendorObjId,
//       ...(type === "integration"
//         ? {
//             platform,
//             details: getIntegrationDetails(),
//           }
//         : {
//             platform: platform,
//             enabled: true,
//             details: getServiceDetails(),
//           }),
//     };

//     const url = `${apiurl}/admin/v1/config/${type}/add`;

//     const config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: JSON.stringify(requestData),
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         if (response.data.success) {
//           FetchIntrigationList();
//           setChoosenInstallCard(null);
//           setFormData(null);
//           setLoading(false);
//           setIsExplore(false);
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//         setLoading(false);
//       });
//   };

//   const removeIntegation = (platform) => {
//     setLoading(true);
//     console.log("platformplatform", platform);
//     const containt = IntrigationData.find((item) =>
//       item.title === (platform?.service || platform?.platform)
//         ? item.badgeText
//         : ""
//     );
//     const integrationType =
//       containt?.badgeText === "service" ? "service" : "platform";
//     const route = containt?.badgeText === "service" ? "service" : "integration";
//     let data = JSON.stringify({
//       vendorObjId: vendorObjId,
//       platform: platform?.service || platform?.platform,
//     });

//     let config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/config/${route}/remove`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         if (response.data.success) {
//           FetchIntrigationList();
//           setLoading(false);
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//         setLoading(false);
//       });
//   };

//   const updateIntegratedApp = (detail) => {
//     setLoading(true);
//     let data = JSON.stringify({
//       vendorObjId: vendorObjId,
//       platform: detail?.title,
//       details: formData,
//     });

//     let config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: `${apiurl}/admin/v1/config/${detail?.badgeText}/update`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: data,
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         if (response.data.success) {
//           FetchIntrigationList();
//           setLoading(false);
//           setChoosenInstallCard("");
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//         setLoading(false);
//       });
//   };
//   return (
//     <Layout>
//       {choosenInstallCard?.title === "gupshup" && (
//         <Card.AddPopUp
//           height="auto"
//           cardContainerClassName="z-30"
//           removePopUp={() => setChoosenInstallCard(null)}
//         >
//           <div className="flex gap-4 items-center">
//             <img src="/gupshup_logo.svg" className="h-8" />
//             <p className="font-semibold text-lg capitalize">
//               {choosenInstallCard?.title} Configuration
//             </p>
//           </div>

//           {/* inputs */}
//           <div className="flex flex-col items-center justify-center w-full px-4 md:px-10 py-6">
//             <div className="w-full max-w-lg bg-white rounded-lg  p-6 transition transform ">
//               <form
//                 className="space-y-4 "
//                 onSubmit={(e) => {
//                   e.preventDefault();
//                   if (isEdit) {
//                     updateIntegratedApp(choosenInstallCard);
//                   } else {
//                     SubmitInstallConfigurations(
//                       e,
//                       choosenInstallCard?.title,
//                       choosenInstallCard?.badgeText
//                     );
//                   }
//                 }}
//               >
//                 <Input.Normal
//                   label="userid"
//                   name=""
//                   placeholder="Enter Userid"
//                   required
//                   // value={setShowInstallOptions}
//                 />
//                 <Input.Normal
//                   label="password"
//                   placeholder="Enter password"
//                   required
//                 />
//                 <Input.Normal
//                   label="template variable"
//                   placeholder="Enter template variable"
//                   required
//                 />

//                 <label class="inline-flex items-center cursor-pointer">
//                   <input type="checkbox" value="" class="sr-only peer" />
//                   <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300  rounded-full peer  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-blue-600"></div>
//                   <span class="ms-3 text-sm font-medium text-gray-900 ">
//                     multimedia
//                   </span>
//                 </label>
//                 <div className="flex justify-end">
//                   <button
//                     // onClick={() => onSave(smtpDetails)}
//                     className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 transition"
//                   >
//                     Install
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </Card.AddPopUp>
//       )}
//       {choosenInstallCard?.title === "shopify" && (
//         <Card.AddPopUp
//           height="auto"
//           cardContainerClassName="z-30"
//           removePopUp={() => setChoosenInstallCard(null)}
//         >
//           <div className="flex gap-4 items-center">
//             <img src={choosenInstallCard?.logoSrc} className="h-8" />
//             <p className="font-semibold text-lg capitalize">
//               {choosenInstallCard?.title} Configuration
//             </p>
//           </div>

//           <div className="flex flex-col items-center justify-center w-full px-4 md:px-10 py-6">
//             <div className="w-full max-w-lg bg-white rounded-lg  p-6 transition transform ">
//               <form
//                 className="space-y-4"
//                 onSubmit={(e) => {
//                   e.preventDefault();
//                   if (isEdit) {
//                     updateIntegratedApp(choosenInstallCard);
//                   } else {
//                     SubmitInstallConfigurations(
//                       e,
//                       choosenInstallCard?.title,
//                       choosenInstallCard?.badgeText
//                     );
//                   }
//                 }}
//               >
//                 <Input.Normal
//                   label="Store url"
//                   placeholder="url"
//                   name="storeUrl"
//                   onChange={InputHandler}
//                   value={formData?.storeUrl}
//                   required
//                 />
//                 <Input.Normal
//                   label="Api key"
//                   placeholder="key"
//                   name="apiKey"
//                   onChange={InputHandler}
//                   value={formData?.apiKey}
//                   required
//                 />
//                 <Input.Normal
//                   label="Api Secret"
//                   placeholder="secret"
//                   name="apiSecret"
//                   onChange={InputHandler}
//                   value={formData?.apiSecret}
//                   required
//                 />
//                 <Input.Normal
//                   label="Access token"
//                   placeholder="token"
//                   name="accessToken"
//                   onChange={InputHandler}
//                   value={formData?.accessToken}
//                   required
//                 />
//                 <div className="flex justify-end mt-6">
//                   <button
//                     type="submit"
//                     className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 transition"
//                   >
//                     {isEdit ? "Update" : "Install"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </Card.AddPopUp>
//       )}
//       {choosenInstallCard?.title === "SMTP" && (
//         <Card.AddPopUp
//           height="auto"
//           cardContainerClassName="z-30"
//           removePopUp={() => setChoosenInstallCard(null)}
//         >
//           <div className="flex gap-4 items-center">
//             <img src={choosenInstallCard?.logoSrc} className="h-8" />

//             <p className="font-semibold text-lg capitalize">
//               {choosenInstallCard?.title} Configuration
//             </p>
//           </div>

//           <SMTPCard
//             onChange={InputHandler}
//             formData={formData}
//             onSubmit={(e) => {
//               e.preventDefault();
//               if (isEdit) {
//                 updateIntegratedApp(choosenInstallCard);
//               } else {
//                 SubmitInstallConfigurations(
//                   e,
//                   choosenInstallCard?.title,
//                   choosenInstallCard?.badgeText
//                 );
//               }
//             }}
//           />
//         </Card.AddPopUp>
//       )}

//       {choosenInstallCard?.title === "twilio" && (
//         <Card.AddPopUp
//           height="auto"
//           cardContainerClassName="z-30"
//           removePopUp={() => setChoosenInstallCard(null)}
//         >
//           <div className="flex gap-4 items-center">
//             <img src={choosenInstallCard?.logoSrc} className="h-8" />

//             <p className="font-semibold text-lg ">
//               {choosenInstallCard?.title} Configuration
//             </p>
//           </div>

//           <div className="flex flex-col items-center justify-center w-full px-4 md:px-10 py-6">
//             <div className="w-full max-w-lg bg-white rounded-lg  p-6 transition transform ">
//               <form
//                 className="space-y-4 "
//                 onSubmit={(e) => {
//                   e.preventDefault();
//                   if (isEdit) {
//                     updateIntegratedApp(choosenInstallCard);
//                   } else {
//                     SubmitInstallConfigurations(
//                       e,
//                       choosenInstallCard?.title,
//                       choosenInstallCard?.badgeText
//                     );
//                   }
//                 }}
//               >
//                 <Input.Normal
//                   label="Api key"
//                   placeholder="key"
//                   name="apiKey"
//                   onChange={InputHandler}
//                 />
//                 <Input.Normal
//                   label="Api Secret"
//                   placeholder="secret"
//                   name="apiSecret"
//                   onChange={InputHandler}
//                 />
//                 <Input.Normal
//                   label="Sender Id"
//                   placeholder="senderId"
//                   name="senderId"
//                   onChange={InputHandler}
//                 />
//                 <div className="flex justify-end mt-6">
//                   <button className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 transition">
//                     Install
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </Card.AddPopUp>
//       )}
//       {choosenInstallCard?.title === "fynd" && (
//         <Card.AddPopUp
//           height="auto"
//           cardContainerClassName="z-30"
//           removePopUp={() => setChoosenInstallCard(null)}
//         >
//           <div className="flex gap-4 items-center">
//             <img src={choosenInstallCard?.logoSrc} className="h-8" />
//             <p className="font-semibold text-lg ">
//               {choosenInstallCard?.title} Configuration
//             </p>
//           </div>

//           <div className="flex flex-col items-center justify-center w-full px-4 md:px-10 py-6">
//             <div className="w-full max-w-lg bg-white rounded-lg  p-6 transition transform ">
//               <form
//                 className="space-y-4 "
//                 onSubmit={(e) => {
//                   e.preventDefault();
//                   if (isEdit) {
//                     updateIntegratedApp(choosenInstallCard);
//                   } else {
//                     SubmitInstallConfigurations(
//                       e,
//                       choosenInstallCard?.title,
//                       choosenInstallCard?.badgeText
//                     );
//                   }
//                 }}
//               >
//                 <Input.Normal
//                   label="Api key"
//                   placeholder="key"
//                   name="apiKey"
//                   onChange={InputHandler}
//                 />
//                 <Input.Normal
//                   label="Api Secret"
//                   placeholder="secret"
//                   name="apiSecret"
//                   onChange={InputHandler}
//                 />
//                 <Input.Normal
//                   label="Sender Id"
//                   placeholder="senderId"
//                   name="senderId"
//                   onChange={InputHandler}
//                 />
//                 <div className="flex justify-end mt-6">
//                   <button className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 transition">
//                     Install
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </Card.AddPopUp>
//       )}
//       {choosenInstallCard?.title === "Genesis" && (
//         <Card.AddPopUp
//           height="auto"
//           cardContainerClassName="z-30"
//           removePopUp={() => setChoosenInstallCard(null)}
//         >
//           <div className="flex gap-4 items-center">
//             <img src={choosenInstallCard?.logoSrc} className="h-8" />
//             <p className="font-semibold text-lg capitalize">
//               {choosenInstallCard?.title} Configuration
//             </p>
//           </div>

//           <div className="flex flex-col items-center justify-center w-full px-4 md:px-10 py-6">
//             <div className="w-full max-w-lg bg-white rounded-lg  p-6 transition transform ">
//               <form
//                 className="space-y-4 "
//                 onSubmit={(e) => {
//                   e.preventDefault();
//                   if (isEdit) {
//                     updateIntegratedApp(choosenInstallCard);
//                   } else {
//                     SubmitInstallConfigurations(
//                       e,
//                       choosenInstallCard?.title,
//                       choosenInstallCard?.badgeText
//                     );
//                   }
//                 }}
//               >
//                 <Input.Normal
//                   label="Api key"
//                   placeholder="key"
//                   name="apiKey"
//                   onChange={InputHandler}
//                 />
//                 <Input.Normal
//                   label="Api Secret"
//                   placeholder="secret"
//                   name="apiSecret"
//                   onChange={InputHandler}
//                 />
//                 <Input.Normal
//                   label="Sender Id"
//                   placeholder="senderId"
//                   name="senderId"
//                   onChange={InputHandler}
//                 />
//                 <div className="flex justify-end mt-6">
//                   <button className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 transition">
//                     Install
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </Card.AddPopUp>
//       )}
//       {choosenInstallCard?.title === "kringle" && (
//         <Card.AddPopUp
//           height="auto"
//           cardContainerClassName="z-30"
//           removePopUp={() => setChoosenInstallCard(null)}
//         >
//           <div className="flex gap-4 items-center">
//             <img src={choosenInstallCard?.logoSrc} className="h-8" />
//             <p className="font-semibold text-lg capitalize">
//               {choosenInstallCard?.title} Configuration
//             </p>
//           </div>

//           <div className="flex flex-col items-center justify-center w-full px-4 md:px-10 py-6">
//             <div className="w-full max-w-lg bg-white rounded-lg  p-6 transition transform ">
//               <form
//                 className="space-y-4 "
//                 onSubmit={(e) => {
//                   e.preventDefault();
//                   if (isEdit) {
//                     updateIntegratedApp(choosenInstallCard);
//                   } else {
//                     SubmitInstallConfigurations(
//                       e,
//                       choosenInstallCard?.title,
//                       choosenInstallCard?.badgeText
//                     );
//                   }
//                 }}
//               >
//                 <Input.Normal
//                   label="Api key"
//                   placeholder="key"
//                   name="apiKey"
//                   onChange={InputHandler}
//                 />
//                 <Input.Normal
//                   label="Api Secret"
//                   placeholder="secret"
//                   name="apiSecret"
//                   onChange={InputHandler}
//                 />
//                 <Input.Normal
//                   label="Sender Id"
//                   placeholder="senderId"
//                   name="senderId"
//                   onChange={InputHandler}
//                 />
//                 <div className="flex justify-end mt-6">
//                   <button className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 transition">
//                     Install
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </Card.AddPopUp>
//       )}
//       {choosenInstallCard?.title === "opt culture" && (
//         <Card.AddPopUp
//           height="auto"
//           cardContainerClassName="z-30"
//           removePopUp={() => setChoosenInstallCard(null)}
//         >
//           <div className="flex gap-4 items-center">
//             <img src={choosenInstallCard?.logoSrc} className="h-8" />
//             <p className="font-semibold text-lg capitalize">
//               {choosenInstallCard?.title} Configuration
//             </p>
//           </div>

//           <div className="flex flex-col items-center justify-center w-full px-4 md:px-10 py-6">
//             <div className="w-full max-w-lg bg-white rounded-lg  p-6 transition transform ">
//               <form
//                 className="space-y-4 "
//                 onSubmit={(e) => {
//                   e.preventDefault();
//                   if (isEdit) {
//                     updateIntegratedApp(choosenInstallCard);
//                   } else {
//                     SubmitInstallConfigurations(
//                       e,
//                       choosenInstallCard?.title,
//                       choosenInstallCard?.badgeText
//                     );
//                   }
//                 }}
//               >
//                 <Input.Normal
//                   label="Api key"
//                   placeholder="key"
//                   name="apiKey"
//                   onChange={InputHandler}
//                 />
//                 <Input.Normal
//                   label="Api Secret"
//                   placeholder="secret"
//                   name="apiSecret"
//                   onChange={InputHandler}
//                 />
//                 <Input.Normal
//                   label="Sender Id"
//                   placeholder="senderId"
//                   name="senderId"
//                   onChange={InputHandler}
//                 />
//                 <div className="flex justify-end mt-6">
//                   <button className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 transition">
//                     Install
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </Card.AddPopUp>
//       )}
//       {choosenInstallCard?.title === "invite referral" && (
//         <Card.AddPopUp
//           height="auto"
//           cardContainerClassName="z-30"
//           removePopUp={() => setChoosenInstallCard(null)}
//         >
//           <div className="flex gap-4 items-center">
//             <img src={choosenInstallCard?.logoSrc} className="h-8" />
//             <p className="font-semibold text-lg capitalize">
//               {choosenInstallCard?.title} Configuration
//             </p>
//           </div>

//           <div className="flex flex-col items-center justify-center w-full px-4 md:px-10 py-6">
//             <div className="w-full max-w-lg bg-white rounded-lg  p-6 transition transform ">
//               <form
//                 className="space-y-4 "
//                 onSubmit={(e) => {
//                   e.preventDefault();
//                   if (isEdit) {
//                     updateIntegratedApp(choosenInstallCard);
//                   } else {
//                     SubmitInstallConfigurations(
//                       e,
//                       choosenInstallCard?.title,
//                       choosenInstallCard?.badgeText
//                     );
//                   }
//                 }}
//               >
//                 <Input.Normal
//                   label="Api key"
//                   placeholder="key"
//                   name="apiKey"
//                   onChange={InputHandler}
//                 />
//                 <Input.Normal
//                   label="Api Secret"
//                   placeholder="secret"
//                   name="apiSecret"
//                   onChange={InputHandler}
//                 />
//                 <Input.Normal
//                   label="Sender Id"
//                   placeholder="senderId"
//                   name="senderId"
//                   onChange={InputHandler}
//                 />
//                 <div className="flex justify-end mt-6">
//                   <button className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 transition">
//                     Install
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </Card.AddPopUp>
//       )}

//       {isExplore && (
//         <Card.AddPopUp
//           removePopUp={() => setIsExplore(false)}
//           width="75%"
//           height="90%"
//         >
//           <SearchContainer
//             placeholder="Search your app ..."
//             ContainerclassName="bg-white sticky top-0 pb-1"
//           />
//           <div className="grid grid-cols-2 gap-2 mt-2">
//             {IntrigationData.map((item, index) => {
//               return (
//                 <AppCard
//                   logoSrc={item?.logoSrc}
//                   title={item?.title}
//                   description={item?.description}
//                   badgeText={item?.badgeText}
//                   badgeIcon={item?.badgeIcon}
//                   onInstall={() => setChoosenInstallCard(item)}
//                 />
//               );
//             })}
//           </div>
//         </Card.AddPopUp>
//       )}
//       <Container overflow={"overflow-scroll"}>
//         {loading === true ? (
//           <InfiLoader maintext="Fetching Integration Details" />
//         ) : (
//           <div className="flex flex-wrap justify-between w-full h-full overflow-auto p-4 rounded-md bg-gray-100">
//             {/* Owner and Store Info */}
//             <div className="flex flex-col  py-2 w-full md:flex-row md:space-x-4">
//               {/* Owner Info */}
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5 }}
//                 className="flex flex-col w-full bg-white p-4 rounded-lg shadow-lg overscroll-auto"
//               >
//                 <h2 className="text-lg font-semibold mb-4 text-gray-800">
//                   Owner Information
//                 </h2>
//                 <div className="space-y-3 ">
//                   <Content
//                     label="Name"
//                     value={venderDetails?.ownerDetails?.name}
//                   />
//                   <Content
//                     label="Email"
//                     value={venderDetails?.ownerDetails?.email}
//                   />
//                   <Content
//                     label="Phone"
//                     value={venderDetails?.ownerDetails?.phone}
//                   />
//                 </div>
//               </motion.div>

//               {/* Store Info */}
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: 0.2 }}
//                 className="flex flex-col w-full bg-white p-4 rounded-lg shadow-lg overscroll-auto"
//               >
//                 <h2 className="text-lg font-semibold mb-4  text-gray-800">
//                   Store Information
//                 </h2>
//                 <div className="space-y-3 ">
//                   <Content
//                     label="Store Name"
//                     value={userData?.storeDetails?.storeName}
//                   />
//                   <Content
//                     label="Store Email"
//                     value={userData?.storeDetails?.storeEmail}
//                   />
//                   <Content label="Store Phone" value={userData?.phone} />
//                   <Content
//                     label="Store Address"
//                     value={
//                       <span>
//                         {userData?.addressDetails?.province_code},{" "}
//                         {userData?.addressDetails?.address},{" "}
//                         {userData?.addressDetails?.city}
//                       </span>
//                     }
//                   />
//                 </div>
//               </motion.div>
//             </div>

//             {/* Tabs Section */}
//             <motion.div
//               initial={{ scale: 0.9 }}
//               animate={{ scale: 1 }}
//               transition={{ duration: 0.3 }}
//               className="flex w-full mt-6 justify-between items-center border-b-2 "
//             >
//               <div className="text-xl font-semibold">Intrigrations</div>
//               {/* <div className="flex space-x-6   w-full">
//                 <TabBarItem
//                   label="Services"
//                   isActive={activeSection === "services"}
//                   onClick={() => setActiveSection("services")}
//                 />
//                 <TabBarItem
//                   label="Marketing"
//                   isActive={activeSection === "marketing"}
//                   onClick={() => setActiveSection("marketing")}
//                 />
//               </div> */}
//               <div
//                 className="flex gap-2 items-center cursor-pointer text-sm hover:font-semibold"
//                 onClick={() => setIsExplore(true)}
//               >
//                 Explore <BsArrowRight />
//               </div>
//             </motion.div>

//             {/* Tab Content */}
//             <div className="mt-3 w-full">
//               {/* {activeSection === "marketing" && (
//                 <motion.div
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.5 }}
//                   className="flex flex-col gap-6"
//                 >

//                   <SMTPCard />
//                 </motion.div>
//               )} */}

//               {/* {activeSection === "services" && ( */}
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5 }}
//                 className="flex flex-col gap-1  "
//               >
//                 {showInstallApps &&
//                   showInstallApps
//                     .sort((a, b) => {
//                       const nameA = a?.service || a?.platform || "";
//                       const nameB = b?.service || b?.platform || "";
//                       return nameA.localeCompare(nameB);
//                     })
//                     .map((item, index) => {
//                       const matchedIntegration = IntrigationData.find(
//                         (data) =>
//                           data?.title === (item?.service || item?.platform)
//                       );

//                       console.log("matchedIntegration", matchedIntegration);
//                       return (
//                         <div key={index}>
//                           <InstalledCard
//                             logoSrc={matchedIntegration?.logoSrc || ""}
//                             title={item?.service || item?.platform}
//                             badgeText={matchedIntegration?.badgeText}
//                             showInstallOptions={showInstallOptions}
//                             setShowInstallOptions={setShowInstallOptions}
//                             onClickDot={() =>
//                               setShowInstallOptions(
//                                 item?.serviceType || item?.platform
//                               )
//                             }
//                             description={matchedIntegration?.description}
//                             dotClassName={`${
//                               index !== showInstallApps.length - 1
//                                 ? "top-1/2 -translate-y-1/2"
//                                 : "-translate-y-[90%]"
//                             }`}
//                             data={item}
//                             removeIntegation={removeIntegation}
//                             setChoosenInstallCard={setChoosenInstallCard}
//                             setFormData={setFormData}
//                             setIsEdit={setIsEdit}
//                           />
//                         </div>
//                       );
//                     })}
//               </motion.div>
//             </div>
//           </div>
//         )}
//       </Container>
//       {showPopup && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
//           <div className="bg-white p-8 rounded-lg">
//             <h2 className="text-2xl font-bold mb-4">
//               {popupType.charAt(0).toUpperCase() + popupType.slice(1)}{" "}
//               Integration
//             </h2>
//             <input
//               type="text"
//               placeholder="API Endpoint"
//               className="w-full p-2 mb-4 border rounded"
//             />
//             <input
//               type="text"
//               placeholder="Access Token"
//               className="w-full p-2 mb-4 border rounded"
//             />
//             <input
//               type="text"
//               placeholder="Secret Key"
//               className="w-full p-2 mb-4 border rounded"
//             />
//             <input
//               type="text"
//               placeholder="API Key"
//               className="w-full p-2 mb-4 border rounded"
//             />
//             <input
//               type="text"
//               placeholder="Version"
//               className="w-full p-2 mb-4 border rounded"
//             />
//             <div className="flex justify-end">
//               <button
//                 onClick={() => setShowPopup(false)}
//                 className="bg-gray-300 text-gray-800 px-4 py-2 rounded mr-2"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={() => setShowPopup(false)}
//                 className="bg-blue-500 text-white px-4 py-2 rounded"
//               >
//                 Install
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </Layout>
//   );
// };

// export default Integration;

// const VerificationCard = ({
//   title,
//   isVerified,
//   details,
//   document,
//   setDocument,
//   onSubmit,
// }) => (
//   <div className="bg-white p-6 rounded-lg shadow-md border">
//     <div className="flex items-center justify-between">
//       <h3 className="text-lg font-semibold">{title}</h3>
//       <span
//         className={`px-2 py-1 text-xs rounded ${
//           isVerified
//             ? "bg-green-100 text-green-600"
//             : "bg-yellow-100 text-yellow-600"
//         }`}
//       >
//         {isVerified ? "Verified" : "Pending"}
//       </span>
//     </div>
//     <div className="mt-4 flex items-center space-x-4">
//       <input
//         type="file"
//         className="hidden"
//         id={`${title}-doc`}
//         onChange={(e) => setDocument(e.target.files[0])}
//       />
//       <label
//         htmlFor={`${title}-doc`}
//         className="cursor-pointer bg-gray-100 px-4 py-2 rounded hover:bg-gray-200 flex items-center"
//       >
//         <FiUpload className="mr-2" /> Upload Document
//       </label>
//       {document && (
//         <span className="text-gray-600 text-sm">{document.name}</span>
//       )}
//     </div>
//     <button
//       onClick={onSubmit}
//       className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
//     >
//       Submit
//     </button>
//   </div>
// );

// // Example: ToggleSwitch Component
// const ToggleSwitch = ({ label, isActive, onClick }) => (
//   <div className="flex justify-between items-center py-2 border-b">
//     <span className="text-sm font-medium text-gray-700">{label}</span>
//     <div
//       onClick={onClick}
//       className={`w-12 h-6 flex items-center rounded-full cursor-pointer ${
//         isActive ? "bg-blue-500" : "bg-gray-300"
//       }`}
//     >
//       <div
//         className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${
//           isActive ? "translate-x-6" : ""
//         }`}
//       />
//     </div>
//   </div>
// );

// const SMTPCard = ({ onSave, onGetAll, onSubmit, onChange, formData }) => {
//   // const [smtpDetails, setSmtpDetails] = useState({
//   //   host: "",
//   //   port: "",
//   //   username: "",
//   //   password: "",
//   //   fromEmail: "",
//   //   secure: false,
//   // });

//   // const handleInputChange = (e) => {
//   //   const { name, value } = e.target;
//   //   setSmtpDetails({ ...smtpDetails, [name]: value });
//   // };

//   // const handleToggleSecure = () => {
//   //   setSmtpDetails((prev) => ({ ...prev, secure: !prev.secure }));
//   // };

//   return (
//     <div className="flex flex-col items-center justify-center w-full px-4 md:px-10 py-6">
//       <div className="w-full max-w-lg bg-white rounded-lg  p-6 transition transform ">
//         <form className="space-y-4 " onSubmit={onSubmit}>
//           {/* Host */}
//           <div className="grid grid-cols-2 gap-2">
//             <div className="flex flex-col">
//               <label
//                 htmlFor="host"
//                 className="text-sm font-medium text-gray-700"
//               >
//                 Host
//               </label>
//               <input
//                 type="text"
//                 name="host"
//                 value={formData?.host}
//                 onChange={onChange}
//                 placeholder="Enter SMTP Host"
//                 className="px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500 focus:outline-none"
//               />
//             </div>
//             {/* Port */}
//             <div className="flex flex-col">
//               <label
//                 htmlFor="port"
//                 className="text-sm font-medium text-gray-700"
//               >
//                 Port
//               </label>
//               <input
//                 type="number"
//                 name="port"
//                 value={formData?.port}
//                 onChange={onChange}
//                 placeholder="Enter Port"
//                 className="px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500 focus:outline-none"
//               />
//             </div>
//           </div>
//           {/* Username */}
//           <div className="flex flex-col">
//             <label
//               htmlFor="username"
//               className="text-sm font-medium text-gray-700"
//             >
//               Username
//             </label>
//             <input
//               type="text"
//               name="username"
//               value={formData?.username}
//               onChange={onChange}
//               placeholder="Enter Username"
//               className="px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500 focus:outline-none"
//             />
//           </div>
//           {/* Password */}
//           <div className="flex flex-col">
//             <label
//               htmlFor="password"
//               className="text-sm font-medium text-gray-700"
//             >
//               Password
//             </label>
//             <input
//               type="password"
//               name="password"
//               value={formData?.password}
//               onChange={onChange}
//               placeholder="Enter Password"
//               className="px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500 focus:outline-none"
//             />
//           </div>
//           {/* From Email */}
//           <div className="flex flex-col">
//             <label
//               htmlFor="fromEmail"
//               className="text-sm font-medium text-gray-700"
//             >
//               From Email
//             </label>
//             <input
//               type="email"
//               name="fromEmail"
//               value={formData?.fromEmail}
//               onChange={onChange}
//               placeholder="Enter From Email"
//               className="px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500 focus:outline-none"
//             />
//           </div>
//           {/* Secure Toggle */}
//           {/* <div className="flex items-center">
//             <label
//               htmlFor="secure"
//               className="text-sm font-medium text-gray-700 mr-2"
//             >
//               Secure Connection
//             </label>
//             <div
//               className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer ${
//                 smtpDetails.secure ? "bg-green-500" : "bg-gray-300"
//               }`}
//               onClick={handleToggleSecure}
//             >
//               <div
//                 className={`bg-white w-3 h-3 lg:w-4 lg:h-4 rounded-full shadow-md transform ${
//                   smtpDetails.secure ? "translate-x-6" : ""
//                 } transition-transform`}
//               />
//             </div>
//           </div> */}
//           <div className="flex justify-end mt-6">
//             {/* <button
//             onClick={() => onGetAll()}
//             className="px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-700 transition"
//           >
//             Get All
//           </button> */}
//             <button
//               type="submit"
//               className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 transition"
//             >
//               Install
//             </button>
//           </div>
//         </form>
//         {/* Actions */}
//       </div>
//     </div>
//   );
// };

// const InstalledCard = ({
//   logoSrc,
//   title,
//   icon,
//   badgeText,
//   badgeClassName = "text-teal-600 bg-teal-100",
//   buttonText = "Install",
//   onButtonClick,
//   onClickDot,
//   showInstallOptions,
//   setShowInstallOptions,
//   descriptionClassName,
//   removeIntegation,
//   description,
//   data,
//   setFormData,
//   setChoosenInstallCard,
//   setIsEdit,
// }) => {
//   const ref = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (ref.current && !ref.current.contains(event.target)) {
//         setShowInstallOptions("");
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);
//   const [deletePopup, setDeletePopup] = useState(false);

//   const formatKey = (key) => {
//     return key.replace(/([A-Z])/g, " $1").trim();
//   };
//   return (
//     <div
//       className=" cursor-pointer bg-white rounded-lg p-4"
//       onClick={() => setShowInstallOptions(data)}
//     >
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-4">
//           <div className="w-8 h-8 rounded-md flex justify-center items-center">
//             {logoSrc ? (
//               <img src={logoSrc} alt={`${title} logo`} className="h-full" />
//             ) : (
//               icon
//             )}
//           </div>
//           <div className="font-medium capitalize">
//             <div className="capitalize">{title}</div>
//             <span
//               className={`flex items-center px-1 text-[0.55rem] font-medium rounded-md ${badgeClassName}`}
//             >
//               {badgeText}
//             </span>
//           </div>
//         </div>

//         <div className="relative  ">
//           <FaChevronDown />

//           {/* <HiDotsHorizontal onClick={() => setShowInstallOptions(title)} /> */}
//           {/* {showInstallOptions === title && (
//           <div
//             ref={ref}
//             className={`absolute flex flex-col  shadow-md rounded-md bg-white drop-shadow  p-2 right-5  ${dotClassName} `}
//           >
//             <button className="flex items-center gap-2 p-2 pr-6 rounded-md hover:bg-zinc-100">
//               <CgDetailsMore className="text-black" />{" "}
//               <span className="text-sm"> Details</span>
//             </button>
//             <button
//               className="flex items-center gap-2 p-2 pr-6 rounded-md hover:bg-red-50"
//               onClick={() => removeIntegation(title)}
//             >
//               <RiDeleteBin6Fill className="text-red-500 " />{" "}
//               <span className="text-sm"> Delete</span>
//             </button>
//           </div>
//         )} */}
//         </div>
//       </div>
//       {(showInstallOptions?.service || showInstallOptions?.platform) ===
//         title && (
//         <div
//           className={`bg-zinc-50 flex px-4 mt-2 flex-col rounded-md    p-2  ${descriptionClassName} `}
//         >
//           {data?.details &&
//             Object.entries(data?.details).map(([key, value]) => (
//               <li key={key} className="flex text-sm">
//                 <span className=" w-32 capitalize text-zinc-700">
//                   {formatKey(key)}:
//                 </span>
//                 <span className="text-zinc-400 ">{value || "N/A"}</span>
//               </li>
//             ))}

//           {description && (
//             <div className="text-zinc-400 mt-2 text-sm">{description}</div>
//           )}

//           <div className="flex justify-end mt-2">
//             {!deletePopup ? (
//               <>
//                 <button
//                   onClick={() => {
//                     setChoosenInstallCard(
//                       IntrigationData.find((item) => item.title === title)
//                     );
//                     setFormData(data?.details);
//                     setIsEdit(title);
//                   }}
//                   className="flex items-center gap-2 p-2 pr-6 rounded-md hover:bg-zinc-100"
//                 >
//                   <CiEdit className="text-black" />
//                   <span className="text-sm"> Edit</span>
//                 </button>
//                 <button
//                   onClick={() => setDeletePopup(true)}
//                   className="flex items-center gap-2 p-2 pr-6 rounded-md hover:bg-red-50"
//                 >
//                   <RiDeleteBin6Fill className="text-red-500 " />
//                   <span className="text-sm"> Delete</span>
//                 </button>
//               </>
//             ) : (
//               <div className="text-red-500 flex gap-2 items-center">
//                 <span className="font-semibold">
//                   Are you sure you want to delete
//                 </span>
//                 <button
//                   className="bg-zinc-200 text-black px-3 py-0.5 rounded-md"
//                   onClick={() => setDeletePopup(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   className="bg-red-500 text-white px-3 py-0.5 rounded-md"
//                   onClick={() => removeIntegation(data)}
//                 >
//                   Delete
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const AppCard = ({
//   logoSrc,
//   title,
//   icon,
//   description = "App description goes here",
//   badgeText = "Built for Shopify",
//   badgeImage = null,
//   badgeIcon,
//   onInstall = () => {},
// }) => {
//   return (
//     <div className="w-full p-4 bg-white border border-gray-200 rounded-lg">
//       {/* Icon and Title */}
//       <div className="flex items-center space-x-4">
//         <div className="w-8 h-8 rounded-md flex justify-center items-center">
//           {logoSrc ? (
//             <img src={logoSrc} alt={`${title} logo`} className="h-full" />
//           ) : (
//             icon
//           )}
//         </div>
//         <div>
//           <h2 className="text-lg font-semibold">{title}</h2>
//         </div>
//       </div>

//       {/* Description */}
//       <p className="mt-2 text-sm text-gray-600">{description}</p>

//       {/* Badge and Install Button */}
//       <div className="flex items-center justify-between mt-2">
//         <div className="flex items-center space-x-2">
//           <span className="flex items-center px-2 py-0.5 text-xs font-medium text-teal-600 bg-teal-100 rounded-md">
//             {badgeImage ? (
//               <img
//                 src={badgeImage}
//                 alt="Badge"
//                 className="w-8 h-8 rounded-full"
//               />
//             ) : (
//               badgeIcon
//             )}
//             {badgeText}
//           </span>
//         </div>

//         <button
//           onClick={onInstall}
//           className="flex items-center px-5 py-0.5 text-sm rounded-full justify-center text-gray-500 hover:bg-green-50 border border-gray-300 hover:text-green-500 hover:border-green-400"
//         >
//           Install
//         </button>
//       </div>
//     </div>
//   );
// };

import React, { useState, useEffect, useRef, useCallback } from "react";
import Layout, { Container } from "../components/layout";
import { RiDeleteBin6Fill } from "react-icons/ri";
import Input from "../components/inputContainer";
import { useUser } from "../config/userProvider";
import axios from "axios";
import { apiurl } from "../config/config";
import { InfiLoader } from "../components/loader";
import { motion } from "framer-motion";
import { BsArrowRight } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import { FaChevronDown } from "react-icons/fa6";
import Card from "../components/card";
import SearchContainer from "../components/searchContainer";

const IntrigationData = [
  {
    logoSrc: "/gupshup_logo.svg",
    title: "gupshup",
    description:
      "Boost sales with customer photos, videos, and other social proof",
    badgeText: "service",
  },
  {
    logoSrc: "/shopify_icon.svg",
    title: "shopify",
    description:
      "Boost sales with customer photos, videos, and other social proof",
    badgeText: "integration",
  },
  {
    logoSrc: "/Gmail_icon_(2020).svg",
    title: "SMTP",
    description:
      "Boost sales with customer photos, videos, and other social proof",
    badgeText: "service",
  },
  {
    logoSrc: "/twilio-tile.svg",
    title: "twilio",
    description:
      "Boost sales with customer photos, videos, and other social proof",
    badgeText: "service",
  },
  {
    logoSrc: "/fynd.png",
    title: "fynd",
    description:
      "Boost sales with customer photos, videos, and other social proof",
    badgeText: "integration",
  },
  {
    logoSrc: "/ginesys.png",
    title: "Genesis",
    description:
      "Boost sales with customer photos, videos, and other social proof",
    badgeText: "integration",
  },
  {
    logoSrc: "/kringle.png",
    title: "kringle",
    description:
      "Boost sales with customer photos, videos, and other social proof",
    badgeText: "integration",
  },
  {
    logoSrc: "/optculture.png",
    title: "opt culture",
    description:
      "Boost sales with customer photos, videos, and other social proof",
    badgeText: "integration",
  },
  {
    logoSrc: "/invitereferrals.png",
    title: "invite referral",
    description:
      "Boost sales with customer photos, videos, and other social proof",
    badgeText: "integration",
  },
];

const Integration = () => {
  const { userData } = useUser();
  const [loading, setLoading] = useState(false);
  const [updateDetail, setUpdateDetail] = useState(null);
  const [venderDetails, setVenderDetails] = useState(null);

  // PAN & GST States
  const [panNumber, setPanNumber] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [verifiedPan, setVerifiedPan] = useState(false);
  const [verifiedGst, setVerifiedGst] = useState(false);

  console.log("gastNumber", gstNumber);
  console.log("verifiedPan", verifiedPan);
  console.log("verifiedGst", verifiedGst);

  const [panError, setPanError] = useState("");
  const [gstError, setGstError] = useState("");

  // Installation States
  const [isExplore, setIsExplore] = useState(false);
  const [choosenInstallCard, setChoosenInstallCard] = useState(null);
  const [showInstallApps, setShowInstallApps] = useState([]);
  const [showInstallOptions, setShowInstallOptions] = useState(null);
  const [formData, setFormData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const vendorObjId = userData?.vendorDetails?.vendorObjId;

  // Fetch Vendor Details
  useEffect(() => {
    if (!vendorObjId) return;

    setLoading(true);
    axios
      .get(`${apiurl}/api/vendor/get/${vendorObjId}`)
      .then((response) => {
        const data = response.data;
        setVenderDetails(data);
        setUpdateDetail(data.vendorDetails);

        // GST
        const gst = data.vendorDetails?.gstDetails?.gstNumber;
        setGstNumber(gst || "");
        if (gst) setVerifiedGst(!data.vendorDetails?.gstDetails?.gstDocument);

        // PAN
        const pan = data.vendorDetails?.panDetails?.panNumber;
        setPanNumber(pan || "");
        if (pan) setVerifiedPan(!data.vendorDetails?.panDetails?.panDocument);
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  }, [vendorObjId]);

  // PAN Verification Handler
  // const panVarificationHandler = () => {
  //   if (!panNumber || panNumber.length < 10) return;

  //   const data = JSON.stringify({ pan_number: panNumber });

  //   axios
  //     .post(`${apiurl}/admin/v1/validation/pan/validate`, data, {
  //       headers: { "Content-Type": "application/json" },
  //     })
  //     .then((response) => {
  //       if (response.data.success) {
  //         setVerifiedPan(true);
  //         setPanError("");
  //       } else {
  //         setVerifiedPan(false);
  //         setPanError("Incorrect PAN number");
  //       }
  //     })
  //     .catch(() => setPanError("Something went wrong"));
  // };

  //   useEffect(() => {
  //   if (panNumber && panNumber.length >= 10 && !updateDetail?.panDetails?.panNumber) {
  //     panVarificationHandler();
  //   }
  // }, [panNumber, updateDetail?.panDetails?.panNumber]);

  const panVarificationHandler = useCallback(() => {
    if (!panNumber || panNumber.length < 10) return;

    const data = JSON.stringify({ pan_number: panNumber });

    axios
      .post(`${apiurl}/admin/v1/validation/pan/validate`, data, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response) => {
        if (response.data.success) {
          setVerifiedPan(true);
          setPanError("");
        } else {
          setVerifiedPan(false);
          setPanError("Incorrect PAN number");
        }
      })
      .catch(() => setPanError("Something went wrong"));
  }, [panNumber]);

  useEffect(() => {
    if (
      panNumber &&
      panNumber.length >= 10 &&
      !updateDetail?.panDetails?.panNumber
    ) {
      panVarificationHandler();
    }
  }, [panNumber, updateDetail?.panDetails?.panNumber, panVarificationHandler]);

  // Clear Errors
  useEffect(() => {
    const timer = setTimeout(() => {
      setPanError("");
      setGstError("");
    }, 5000);
    return () => clearTimeout(timer);
  }, [panError, gstError]);

  // Fetch Integrations
  // const FetchIntrigationList = () => {
  //   if (!vendorObjId) return;
  //   setLoading(true);

  //   axios
  //     .post(`${apiurl}/admin/v1/config/get`, { vendorObjId })
  //     .then((response) => {
  //       if (response.data.success) {
  //         setShowInstallApps([
  //           ...response.data.data?.integrations,
  //           ...response.data.data?.services,
  //         ]);
  //       }
  //     })
  //     .catch(console.error)
  //     .finally(() => setLoading(false));
  // };

  // useEffect(() => {
  //   FetchIntrigationList();
  // }, [vendorObjId]);

  const FetchIntrigationList = useCallback(() => {
    if (!vendorObjId) return;

    setLoading(true);

    axios
      .post(`${apiurl}/admin/v1/config/get`, { vendorObjId })
      .then((response) => {
        if (response.data.success) {
          setShowInstallApps([
            ...response.data.data?.integrations,
            ...response.data.data?.services,
          ]);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [vendorObjId]);

  useEffect(() => {
    FetchIntrigationList();
  }, [FetchIntrigationList]);

  const InputHandler = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const SubmitInstallConfigurations = (e, platform, type) => {
    e.preventDefault();
    setLoading(true);

    const requestData = {
      vendorObjId,
      ...(type === "integration"
        ? {
            platform,
            details: formData,
          }
        : {
            platform,
            enabled: true,
            details: formData,
          }),
    };

    axios
      .post(`${apiurl}/admin/v1/config/${type}/add`, requestData)
      .then((response) => {
        if (response.data.success) {
          FetchIntrigationList();
          setChoosenInstallCard(null);
          setFormData(null);
          setIsExplore(false);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  const removeIntegation = (platform) => {
    setLoading(true);
    const route = platform?.service ? "service" : "integration";

    axios
      .post(`${apiurl}/admin/v1/config/${route}/remove`, {
        vendorObjId,
        platform: platform?.service || platform?.platform,
      })
      .then((response) => {
        if (response.data.success) FetchIntrigationList();
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  const updateIntegratedApp = (detail) => {
    setLoading(true);
    axios
      .post(`${apiurl}/admin/v1/config/${detail?.badgeText}/update`, {
        vendorObjId,
        platform: detail?.title,
        details: formData,
      })
      .then((response) => {
        if (response.data.success) {
          FetchIntrigationList();
          setChoosenInstallCard(null);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  return (
    <Layout>
      {/* Popups for different integrations */}
      {choosenInstallCard && (
        <Card.AddPopUp
          height="auto"
          cardContainerClassName="z-30"
          removePopUp={() => setChoosenInstallCard(null)}
        >
          <IntegrationForm
            card={choosenInstallCard}
            formData={formData}
            onChange={InputHandler}
            onSubmit={(e) => {
              e.preventDefault();
              if (isEdit) updateIntegratedApp(choosenInstallCard);
              else
                SubmitInstallConfigurations(
                  e,
                  choosenInstallCard.title,
                  choosenInstallCard.badgeText,
                );
            }}
          />
        </Card.AddPopUp>
      )}

      {isExplore && (
        <Card.AddPopUp
          removePopUp={() => setIsExplore(false)}
          width="75%"
          height="90%"
        >
          <SearchContainer
            placeholder="Search your app ..."
            ContainerclassName="bg-white sticky top-0 pb-1"
          />
          <div className="grid grid-cols-2 gap-2 mt-2">
            {IntrigationData.map((item) => (
              <AppCard
                key={item.title}
                {...item}
                onInstall={() => setChoosenInstallCard(item)}
              />
            ))}
          </div>
        </Card.AddPopUp>
      )}

      <Container overflow="overflow-scroll">
        {loading ? (
          <InfiLoader maintext="Fetching Integration Details" />
        ) : (
          <div className="flex flex-wrap justify-between w-full h-full overflow-auto p-4 rounded-md bg-gray-100">
            {/* Owner & Store Info */}
            <div className="flex flex-col py-2 w-full md:flex-row md:space-x-4">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="flex flex-col w-full bg-white p-4 rounded-lg shadow-lg"
              >
                <h2 className="text-lg font-semibold mb-4 text-gray-800">
                  Owner Information
                </h2>
                <div className="space-y-3">
                  <Content
                    label="Name"
                    value={venderDetails?.ownerDetails?.name}
                  />
                  <Content
                    label="Email"
                    value={venderDetails?.ownerDetails?.email}
                  />
                  <Content
                    label="Phone"
                    value={venderDetails?.ownerDetails?.phone}
                  />
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="flex flex-col w-full bg-white p-4 rounded-lg shadow-lg"
              >
                <h2 className="text-lg font-semibold mb-4 text-gray-800">
                  Store Information
                </h2>
                <div className="space-y-3">
                  <Content
                    label="Store Name"
                    value={userData?.storeDetails?.storeName}
                  />
                  <Content
                    label="Store Email"
                    value={userData?.storeDetails?.storeEmail}
                  />
                  <Content label="Store Phone" value={userData?.phone} />
                  <Content
                    label="Store Address"
                    value={`${userData?.addressDetails?.province_code}, ${userData?.addressDetails?.address}, ${userData?.addressDetails?.city}`}
                  />
                </div>
              </motion.div>
            </div>

            {/* Header */}
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              className="flex w-full mt-6 justify-between items-center border-b-2"
            >
              <div className="text-xl font-semibold">Integrations</div>
              <div
                className="flex gap-2 items-center cursor-pointer text-sm hover:font-semibold"
                onClick={() => setIsExplore(true)}
              >
                Explore <BsArrowRight />
              </div>
            </motion.div>

            {/* Installed Integrations */}
            <div className="mt-3 w-full">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="flex flex-col gap-1"
              >
                {showInstallApps
                  .sort((a, b) =>
                    (a.service || a.platform || "").localeCompare(
                      b.service || b.platform || "",
                    ),
                  )
                  .map((item, index) => {
                    const matched = IntrigationData.find(
                      (data) => data.title === (item.service || item.platform),
                    );
                    return (
                      <InstalledCard
                        key={index}
                        {...matched}
                        data={item}
                        showInstallOptions={showInstallOptions}
                        setShowInstallOptions={setShowInstallOptions}
                        removeIntegation={removeIntegation}
                        setChoosenInstallCard={setChoosenInstallCard}
                        setFormData={setFormData}
                        setIsEdit={setIsEdit}
                      />
                    );
                  })}
              </motion.div>
            </div>
          </div>
        )}
      </Container>
    </Layout>
  );
};

export default Integration;

// ====================== HELPER COMPONENTS ======================

const Content = ({ label, value }) => (
  <div className="grid grid-cols-2 text-xs md:text-base">
    <p className="font-semibold">{label}:</p>
    <p className="text-slate-500 break-words">{value || "N/A"}</p>
  </div>
);

const IntegrationForm = ({ card, formData, onChange, onSubmit }) => {
  const isSMTP = card.title === "SMTP";

  return (
    <div className="flex flex-col items-center justify-center w-full px-4 md:px-10 py-6">
      <div className="w-full max-w-lg bg-white rounded-lg p-6">
        <div className="flex gap-4 items-center mb-6">
          <img src={card.logoSrc} alt={`${card.title} logo`} className="h-8" />
          <p className="font-semibold text-lg capitalize">
            {card.title} Configuration
          </p>
        </div>

        <form className="space-y-4" onSubmit={onSubmit}>
          {isSMTP ? (
            <SMTPCard formData={formData} onChange={onChange} />
          ) : (
            // Default form fields for other integrations
            <>
              <Input.Normal
                label="API Key"
                name="apiKey"
                placeholder="Enter API Key"
                onChange={onChange}
                value={formData?.apiKey}
                required
              />
              <Input.Normal
                label="API Secret"
                name="apiSecret"
                placeholder="Enter API Secret"
                onChange={onChange}
                value={formData?.apiSecret}
                required
              />
              <Input.Normal
                label="Sender ID"
                name="senderId"
                placeholder="Enter Sender ID"
                onChange={onChange}
                value={formData?.senderId}
              />
            </>
          )}

          <div className="flex justify-end mt-6">
            <button
              type="submit"
              className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
            >
              {card.isEdit ? "Update" : "Install"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const SMTPCard = ({ formData, onChange }) => (
  <>
    <div className="grid grid-cols-2 gap-2">
      <div className="flex flex-col">
        <label className="text-sm font-medium text-gray-700">Host</label>
        <input
          type="text"
          name="host"
          value={formData?.host || ""}
          onChange={onChange}
          placeholder="smtp.gmail.com"
          className="px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="flex flex-col">
        <label className="text-sm font-medium text-gray-700">Port</label>
        <input
          type="number"
          name="port"
          value={formData?.port || ""}
          onChange={onChange}
          placeholder="587"
          className="px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500"
        />
      </div>
    </div>

    <div className="flex flex-col">
      <label className="text-sm font-medium text-gray-700">Username</label>
      <input
        type="text"
        name="username"
        value={formData?.username || ""}
        onChange={onChange}
        placeholder="Enter Username"
        className="px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500"
      />
    </div>

    <div className="flex flex-col">
      <label className="text-sm font-medium text-gray-700">Password</label>
      <input
        type="password"
        name="password"
        value={formData?.password || ""}
        onChange={onChange}
        placeholder="Enter Password"
        className="px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500"
      />
    </div>

    <div className="flex flex-col">
      <label className="text-sm font-medium text-gray-700">From Email</label>
      <input
        type="email"
        name="fromEmail"
        value={formData?.fromEmail || ""}
        onChange={onChange}
        placeholder="noreply@yourdomain.com"
        className="px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500"
      />
    </div>
  </>
);

const InstalledCard = ({
  logoSrc,
  title,
  badgeText,
  data,
  showInstallOptions,
  setShowInstallOptions,
  removeIntegation,
  setChoosenInstallCard,
  setFormData,
  setIsEdit,
}) => {
  const ref = useRef(null);
  const [deletePopup, setDeletePopup] = useState(false);

  const formatKey = (key) => key.replace(/([A-Z])/g, " $1").trim();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target))
        setShowInstallOptions(null);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setShowInstallOptions]);

  return (
    <div
      className="bg-white rounded-lg p-4 cursor-pointer"
      onClick={() => setShowInstallOptions(data)}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="w-8 h-8 rounded-md flex justify-center items-center">
            <img src={logoSrc} alt={`${title} logo`} className="h-full" />
          </div>
          <div>
            <div className="font-medium capitalize">{title}</div>
            <span className="text-[0.55rem] font-medium px-1.5 py-0.5 bg-teal-100 text-teal-600 rounded-md">
              {badgeText}
            </span>
          </div>
        </div>
        <FaChevronDown />
      </div>

      {(showInstallOptions?.service || showInstallOptions?.platform) ===
        title && (
        <div className="bg-zinc-50 mt-2 p-4 rounded-md">
          {data?.details &&
            Object.entries(data.details).map(([key, value]) => (
              <div key={key} className="flex text-sm py-1">
                <span className="w-32 capitalize text-zinc-700">
                  {formatKey(key)}:
                </span>
                <span className="text-zinc-400">{value || "N/A"}</span>
              </div>
            ))}

          <div className="flex justify-end gap-2 mt-4">
            {!deletePopup ? (
              <>
                <button
                  onClick={() => {
                    setChoosenInstallCard(
                      IntrigationData.find((i) => i.title === title),
                    );
                    setFormData(data?.details);
                    setIsEdit(true);
                  }}
                  className="flex items-center gap-2 px-4 py-2 hover:bg-zinc-100 rounded-md"
                >
                  <CiEdit /> Edit
                </button>
                <button
                  onClick={() => setDeletePopup(true)}
                  className="flex items-center gap-2 px-4 py-2 hover:bg-red-50 text-red-500 rounded-md"
                >
                  <RiDeleteBin6Fill /> Delete
                </button>
              </>
            ) : (
              <div className="flex items-center gap-3 text-red-500">
                <span>Are you sure?</span>
                <button
                  onClick={() => setDeletePopup(false)}
                  className="bg-zinc-200 px-3 py-1 rounded"
                >
                  Cancel
                </button>
                <button
                  onClick={() => removeIntegation(data)}
                  className="bg-red-500 text-white px-3 py-1 rounded"
                >
                  Delete
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const AppCard = ({ logoSrc, title, description, badgeText, onInstall }) => (
  <div className="w-full p-4 bg-white border border-gray-200 rounded-lg">
    <div className="flex items-center space-x-4">
      <div className="w-8 h-8 rounded-md flex justify-center items-center">
        <img src={logoSrc} alt={`${title} logo`} className="h-full" />
      </div>
      <h2 className="text-lg font-semibold">{title}</h2>
    </div>
    <p className="mt-2 text-sm text-gray-600">{description}</p>

    <div className="flex items-center justify-between mt-4">
      <span className="text-xs font-medium text-teal-600 bg-teal-100 px-2 py-1 rounded-md">
        {badgeText}
      </span>
      <button
        onClick={onInstall}
        className="px-5 py-1 text-sm border border-gray-300 rounded-full hover:bg-green-50 hover:text-green-600 hover:border-green-400"
      >
        Install
      </button>
    </div>
  </div>
);
